var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.6 27a.98.98 0 0 0 1-1 33.04 33.04 0 0 1 .76-5.24.96.96 0 0 0-.36-1 1 1 0 0 0-1.16 0 11.08 11.08 0 0 0-4 6 1 1 0 0 0 .18.88.98.98 0 0 0 .78.38ZM29.4 26a1 1 0 0 0 1 .94h2.78a.98.98 0 0 0 .78-.38 1 1 0 0 0 .18-.88 11.08 11.08 0 0 0-4-6 1 1 0 0 0-1.16 0 .96.96 0 0 0-.42 1.06A33.04 33.04 0 0 1 29.4 26ZM22.78 17.62a19.54 19.54 0 0 0-2.2 8.38.96.96 0 0 0 .26.76 1.02 1.02 0 0 0 .74.32h3.84a1.02 1.02 0 0 0 .74-.32.96.96 0 0 0 .26-.76 19.54 19.54 0 0 0-2.2-8.3.24.24 0 0 0-.22-.18h-1.16a.24.24 0 0 0-.06.1ZM17.62 30.94a1 1 0 0 0-1-.94h-2.8a.98.98 0 0 0-.78.38 1 1 0 0 0-.18.88 11 11 0 0 0 4 6 1 1 0 0 0 1.16 0 1.02 1.02 0 0 0 .42-1.08 29.2 29.2 0 0 1-.82-5.24ZM24.2 39.42a20.88 20.88 0 0 0 2.2-8.34.9.9 0 0 0-.26-.76.96.96 0 0 0-.72-.32h-3.84a.96.96 0 0 0-.72.32.9.9 0 0 0-.26.76 20.88 20.88 0 0 0 2.2 8.34h1.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.6 10.34a.96.96 0 0 1-.6-.9V4a4 4 0 0 0-4-4H11a7 7 0 0 0-7 7v35a6 6 0 0 0 6 6h30a4 4 0 0 0 4-4V14a4 4 0 0 0-2.4-3.66ZM8 7a3 3 0 0 1 3-3h25a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H11a3 3 0 0 1-3-3Zm15.5 35.5a14 14 0 1 1 14-14 14 14 0 0 1-14 14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.38 30a1 1 0 0 0-1 .94 29.2 29.2 0 0 1-.8 5.26 1.02 1.02 0 0 0 .42 1.08 1 1 0 0 0 1.16 0 11 11 0 0 0 4-6 1 1 0 0 0-.18-.88.98.98 0 0 0-.78-.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.5191c032.svg";
export { ForwardRef as ReactComponent };